export class RequestsAssignedToMeCountDto {
    pendingApproval: number = 0;
    pendingMMD: number = 0;
    pendingSME: number = 0;
}